import simulatorTrainingRoutes from 'modules/simulatorTrainings/common/routing/routes'

const routes = {
  root: `${simulatorTrainingRoutes.studentIL}/training/details`,
}

export default routes
